import { defineCustomElement, getBooleanAttribute, updateBooleanAttribute, NectaryElement, getLiteralAttribute, updateLiteralAttribute, isAttrTrue, isAttrEqual } from '../utils';
const templateHTML = '<style>:host{text-align:var(--sinch-comp-text-align);display:block;font:var(--sinch-comp-text-font);color:var(--sinch-global-color-text,var(--sinch-sys-color-text-default));--sinch-comp-text-font:var(--sinch-sys-font-body-m);--sinch-comp-text-align:unset}:host([inline]){display:inline}:host([type="s"]){--sinch-comp-text-font:var(--sinch-sys-font-body-s)}:host([type=xs]){--sinch-comp-text-font:var(--sinch-sys-font-body-xs)}:host([type=xxs]){--sinch-comp-text-font:var(--sinch-sys-font-body-xxs)}:host([type="m"][emphasized]){--sinch-comp-text-font:var(--sinch-sys-font-body-emphasize)}:host([type="s"][emphasized]){--sinch-comp-text-font:var(--sinch-sys-font-body-emphasize-s)}:host([ellipsis]){overflow:hidden;text-overflow:ellipsis;white-space:nowrap;--sinch-global-text-white-space:nowrap}</style><slot></slot>';
import { typeValues } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-text', class extends NectaryElement {
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
  }
  connectedCallback() {
    this.#updateRole();
  }
  static get observedAttributes() {
    return ['inline', 'ellipsis', 'emphasized'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (isAttrEqual(oldVal, newVal)) {
      return;
    }
    switch (name) {
      case 'inline':
        {
          this.#updateRole();
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
      case 'ellipsis':
      case 'emphasized':
        {
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
    }
  }
  get type() {
    return getLiteralAttribute(this, typeValues, 'type');
  }
  set type(value) {
    updateLiteralAttribute(this, typeValues, 'type', value);
  }
  set inline(isInline) {
    updateBooleanAttribute(this, 'inline', isInline);
  }
  get inline() {
    return getBooleanAttribute(this, 'inline');
  }
  set ellipsis(isEllipsis) {
    updateBooleanAttribute(this, 'ellipsis', isEllipsis);
  }
  get ellipsis() {
    return getBooleanAttribute(this, 'ellipsis');
  }
  set emphasized(isEmphasized) {
    updateBooleanAttribute(this, 'emphasized', isEmphasized);
  }
  get emphasized() {
    return getBooleanAttribute(this, 'emphasized');
  }
  #updateRole() {
    this.setAttribute('role', getBooleanAttribute(this, 'inline') ? 'text' : 'paragraph');
  }
});